import isMobile from "../isMobile";

function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

$(document).ready(function() {
    $("[data-ads]").each(function(i, e) {
        const $this = $(this);
        const elem = $(e);
        const datas = atob(elem.attr("data-ads"));

        if (IsJsonString(datas)) {
            let datasParsed = JSON.parse(datas);
            datasParsed = typeof datasParsed == "object" ? Object.entries(datasParsed).map(e => e[1]) : datasParsed;

            let datasJson = datasParsed.sort(function() {
                return 0.5 - Math.random();
            });

            datasJson = datasJson.filter(function(e) {
                if (isMobile()) {
                    return e.device.includes("mobile");
                } else {
                    return e.device.includes("desktop");
                }
            });

            if (datasJson.length > 0) {
                let current = datasJson.shift();
                datasJson.push(current);
                $this.html(current.content);

                if (datasJson.length > 1) {
                    setInterval(function() {
                        current = datasJson.shift();
                        datasJson.push(current);
                        $this.html(current.content);
                    }, 60000);
                }
            }
        }
    });
});
